import { showFlash } from './flash_show'

export async function setupClipboard(element) {
  const { default: Clipboard } = await import(/* webpackChunkName: "clipboard" */ 'clipboard')
  const clip = new Clipboard(element)

  clip.on('success', e => {
    e.clearSelection()
    // e.clearSelection removes focus from the button so we need to bring it back
    element.focus()

    if (e.trigger.dataset.clipboardSuccessAlert) {
      const successAlert = document.querySelector(e.trigger.dataset.clipboardSuccessAlert)
      successAlert && (successAlert.style.display = 'block')
      setTimeout(() => {
        successAlert.style.display = 'none'
      }, 2000)
    } else {
      const successAlertText = e.trigger.dataset.clipboardSuccessAlertText
      showFlash('success', successAlertText)
    }

    if (e.trigger.dataset.clipboardSuccessIcon) {
      const defaultIcon = document.querySelector(e.trigger.dataset.clipboardDefaultIcon)
      const successIcon = document.querySelector(e.trigger.dataset.clipboardSuccessIcon)
      defaultIcon && (defaultIcon.style.display = 'none')
      successIcon && (successIcon.style.display = 'block')

      setTimeout(() => {
        successIcon.style.display = 'none'
        defaultIcon.style.display = 'block'
      }, 2000)
    }
  })

  return function () {
    clip.destroy()
  }
}

up.compiler('[data-clipboard-target]', async element => {
  up.destructor(element, await setupClipboard(element))
})

up.compiler('[data-clipboard-text]', async element => {
  up.destructor(element, await setupClipboard(element))
})
